// extracted by mini-css-extract-plugin
export default {"joinVideoCallGuest":"join-video-call-guest_joinVideoCallGuest__5+bI6"};